import React from 'react';
import { appConfig } from 'config';
import './version.css';
export const Version = () => {
    return (React.createElement("div", { className: "version_container" },
        React.createElement("div", null,
            "Build: ",
            appConfig.buildId),
        React.createElement("div", null,
            "Environment: ",
            appConfig.env)));
};
